import { createAsyncThunk } from "@reduxjs/toolkit";
import { getTotalEmissionsData } from "../../config/services/ApiServices";
import { getGlobalSummaryView } from "../../config/services/ApiServices";

 
export const fetchEmissionChart = createAsyncThunk('emission-chart/fetch', async ({ startTime, endTime, customerID, timeZone, siteIds ,query,orderBy}: { startTime: Date, endTime: Date, customerID: string, timeZone?: any, siteIds?:any, query?:any,orderBy:number }) => {
    const response = await getTotalEmissionsData({ startTime, endTime, customerID, timeZone, siteIds,query,orderBy });
    return response;
})

export const fetchEmissionTable = createAsyncThunk('emission-table/fetch', async ({ siteIds, endTime, customerID, timeZone,}: {endTime: Date, customerID: string, timeZone?: any, siteIds?:any })  => {
    const response = await getGlobalSummaryView({endTime, customerID, timeZone,  siteIds });
    return response;
})
